export const defaultRepeatCallValues = [
    {
        name: 'Do not repeat',
        status: 'active',
        value: 0,
    },
    {
        name: '1',
        status: 'active',
        value: 1,
    },
    {
        name: '2',
        status: 'active',
        value: 2,
    },
    {
        name: '3',
        status: 'active',
        value: 3,
    },
];
